export enum EDiscoutType {
    PERCENTAGE = "percentage",
    VALUE = "value",
}